import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Kross Booking**
 *
 * @exports bs_299
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let krossPriceObserver;
    /**
       * @memberOf module:bs_293
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        // On the second version of this BE change from R&R and User Register Page is made as SPA so we need an Observer with page_check.
        if (window.location.hostname.match(/krossbooking.com/)) {
            const loader = document.querySelector('.sploading');
            if (loader) {
                thn.krossChangeMap = thn.debounce(function () {
                    thn.pageCheck();
                }, 250);
                thn.observeDom(loader, thn.krossChangeMap, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.shutdown(function () {
                    thn.stopObserveDom(loader, thn.krossChangeMap);
                    delete thn.krossChangeMap;
                });
            }
        }
    };
    /**
       * @memberOf module:bs_299
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        // Early acces for this version. Only works on this domain kross.travel
        if (!window.location.hostname.match(/kross.travel/)) {
            return widgetData;
        }
        // dates
        if (window.kross_to && window.kross_from) {
            widgetData.dateBegin = window.kross_from.replace(/-/g, '/');
            widgetData.dateEnd = window.kross_to.replace(/-/g, '/');
        }
        else {
            widgetData.dateBegin = translateDate(((document.querySelector('.arrival') || {}).textContent || ''), thn.data.language);
            widgetData.dateEnd = translateDate(((document.querySelector('.departure') || {}).textContent || ''), thn.data.language);
        }
        // Guests, Adults & Children
        widgetData.adults = thn.parseNumber(((document.querySelector('input[name=adults]') || {}).value || '2'));
        widgetData.children = thn.parseNumber(((document.querySelector('input[name=children]') || {}).value || '0'));
        widgetData.guests = widgetData.adults + widgetData.children;
        // price & currency
        const prices = [...(document.querySelectorAll('.listing-outer .min-price'))].map((el) => thn.parseNumber(el.textContent));
        const currency = thn.parseCurrency((document.querySelector('.listing-outer .min-price') || {}).textContent || '');
        if (prices && currency) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
        }
        if (widgetData.price && widgetData.currency) {
            widgetData.set = true;
        }
        else if (document.querySelectorAll('.no-solutions').length) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_299
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        const widgetData = {};
        // Early acces for this version. Only works on this domain krossbooking.com
        if (!window.location.hostname.match(/krossbooking.com/)) {
            return widgetData;
        }
        // OKAY BE CAREFUL. On this version of BE first view is all the rooms of all PIDS of UID 1037812. So, what we do is detect cheapest rooms. Their url is the ones are on the regex under.
        // The others one are flaged as priceSpecial.
        const expensiveRoom = !window.location.pathname.match(/residence-borgo-latino-bilocale|borgo-latino-one-bedroom-apartment|residence-tre-palme-bilocale|residence-tre-palme-one-bedroom-apartment|appartamento-volta-primo-piano|volta-apartment-first-floor-with-balcony|villetta-stella-marina-standard|stella-marina-villa-with-garden/);
        if (thn.data.accountUserId === 1037812 && expensiveRoom) {
            // We are not on the cheapest room, we flag the search as special rate
            widgetData.priceSpecial = 1;
        }
        // dates
        const completeDate = document.querySelector('#tariffaselezionatamore');
        let nights;
        if (completeDate) {
            const dateBegin = completeDate.textContent.match(/\d{2}\/\d{2}\/\d{4}/g)[0].replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1');
            const dateEnd = completeDate.textContent.match(/\d{2}\/\d{2}\/\d{4}/g)[1].replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1');
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd) || 1;
        }
        // Guests, Adults & Children
        widgetData.adults = thn.parseNumber(((document.querySelector('.qtguests') || {}).value || 2));
        widgetData.children = 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // price & currency
        const priceEl = [...document.querySelectorAll('.tot-room-price > span')].map((el) => thn.isVisible(el) && el.textContent.trim()).filter(Boolean);
        const price = priceEl.map((el) => thn.parseNumber(el));
        const currency = (priceEl.length && thn.parseCurrency(priceEl[0])) || 'USD';
        if (price.length && currency && nights) {
            // Packages are shown with the total price, not the price per night
            widgetData.price = price ? (Math.min(...price) / nights).toFixed(2) : Math.min(...price);
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_299
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        // Detect when the user changes the filter, switches between normal rooms and packages
        const loaderContainer = document.querySelector('.loading');
        if (!krossPriceObserver && loaderContainer) {
            krossPriceObserver = thn.debounce(() => ctx.widget.update(), 500);
            thn.observeDom(loaderContainer, krossPriceObserver, {
                childList: false,
                subtree: false,
                attributes: true,
            });
            thn.pageUnload(function () {
                krossPriceObserver.cancel();
                thn.stopObserveDom(loaderContainer, krossPriceObserver);
                krossPriceObserver = null;
            });
        }
    };
    /**
       * @memberOf module:bs_299
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        let dateBeginValue;
        let dateEndValue;
        // Conditional to verify that the reservation confirmation does not appear in the reservation cancellation
        if (!document.querySelector('.codice-res')) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = ((document.querySelector('.codice-res') || {}).textContent || '').trim();
        if (window.location.hostname.match(/kross.travel/)) {
            const datesContainer = document.querySelector('.singleRoomDetails');
            if (datesContainer) {
                dateBeginValue = ((datesContainer.querySelector('div:nth-child(1)>div>.value') || {}).textContent || '');
                dateEndValue = ((datesContainer.querySelector('div:nth-child(3)>div>.value') || {}).textContent || '');
            }
            widgetData.price = thn.parseNumber(((document.querySelector('.primary-box h5.pt-3') || {}).textContent || '').trim());
            widgetData.currency = thn.parseCurrency(((document.querySelector('.primary-box h5.pt-3') || {}).textContent || ''));
        }
        else if (window.location.hostname.match(/krossbooking.com/)) {
            const datesContainer = ((document.querySelector('.review>.row>div:nth-child(2)>div.row>div') || {}).textContent || false);
            if (datesContainer) {
                dateBeginValue = datesContainer.match(/\d{2}\/\d{2}\/\d{4}/g)[0];
                dateEndValue = datesContainer.match(/\d{2}\/\d{2}\/\d{4}/g)[1];
            }
            widgetData.price = thn.parseNumber(((document.querySelector('div.box > div > div:nth-child(4) > div') || {}).textContent || '').trim());
            widgetData.currency = thn.parseCurrency(((document.querySelector('div.box > div > div:nth-child(4) > div') || {}).textContent || ''));
        }
        widgetData.dateBegin = ((dateBeginValue)) ? dateBeginValue.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1') : '';
        widgetData.dateEnd = ((dateEndValue)) ? dateEndValue.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3/$2/$1') : '';
        return widgetData;
    };
    return engine;
}

export { factory };
